import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Deutsche Übersetzungen
const de = {
  translation: {
    // Allgemein
    app: {
      title: 'Energetic Eternity CMS',
      loading: 'Lädt...',
      error: 'Fehler',
      success: 'Erfolgreich',
      cancel: 'Abbrechen',
      save: 'Speichern',
      delete: 'Löschen',
      edit: 'Bearbeiten',
      create: 'Erstellen',
      search: 'Suchen',
      filter: 'Filtern',
      clear: 'Löschen',
      back: 'Zurück',
      next: 'Weiter',
      previous: 'Zurück',
      close: 'Schließen',
      confirm: 'Bestätigen',
      yes: 'Ja',
      no: 'Nein',
      ok: 'OK'
    },

    // Navigation
    nav: {
      dashboard: 'Dashboard',
      content: 'Inhalte',
      users: 'Benutzer',
      analytics: 'Analytics',
      settings: 'Einstellungen',
      blog: 'Blog',
      blogManagement: 'Blog-Verwaltung',
      logout: 'Abmelden'
    },

    // Anmeldung
    auth: {
      login: 'Anmelden',
      logout: 'Abmelden',
      register: 'Registrieren',
      email: 'E-Mail',
      password: 'Passwort',
      confirmPassword: 'Passwort bestätigen',
      forgotPassword: 'Passwort vergessen?',
      rememberMe: 'Angemeldet bleiben',
      loginButton: 'Anmelden',
      registerButton: 'Registrieren',
      loginTitle: 'Anmeldung',
      registerTitle: 'Registrierung',
      loginSubtitle: 'Melden Sie sich in Ihrem Konto an',
      registerSubtitle: 'Erstellen Sie ein neues Konto',
      loginSuccess: 'Erfolgreich angemeldet',
      registerSuccess: 'Registrierung erfolgreich',
      loginError: 'Anmeldung fehlgeschlagen',
      registerError: 'Registrierung fehlgeschlagen',
      invalidCredentials: 'Ungültige Anmeldedaten',
      emailRequired: 'E-Mail ist erforderlich',
      passwordRequired: 'Passwort ist erforderlich',
      passwordMismatch: 'Passwörter stimmen nicht überein',
      emailInvalid: 'Ungültige E-Mail-Adresse',
      confirmLogout: 'Möchten Sie sich wirklich abmelden?'
    },

    // Dashboard
    dashboard: {
      title: 'Dashboard',
      welcome: 'Willkommen zurück',
      overview: 'Übersicht',
      recentContent: 'Neueste Inhalte',
      statistics: 'Statistiken',
      totalUsers: 'Benutzer gesamt',
      totalContent: 'Inhalte gesamt',
      recentActivity: 'Letzte Aktivitäten',
      noRecentContent: 'Keine neuen Inhalte',
      noRecentActivity: 'Keine neuen Aktivitäten'
    },

    // Inhalte
    content: {
      title: 'Inhalte',
      createContent: 'Inhalt erstellen',
      editContent: 'Inhalt bearbeiten',
      deleteContent: 'Inhalt löschen',
      contentTitle: 'Titel',
      contentDescription: 'Beschreibung',
      contentCategory: 'Kategorie',
      contentStatus: 'Status',
      contentType: 'Typ',
      contentFile: 'Datei',
      contentUrl: 'URL',
      contentTags: 'Tags',
      contentPublished: 'Veröffentlicht',
      contentDraft: 'Entwurf',
      contentArchived: 'Archiviert',
      contentFeatured: 'Empfohlen',
      contentViews: 'Aufrufe',
      contentDownloads: 'Downloads',
      contentRating: 'Bewertung',
      contentCreated: 'Erstellt',
      contentUpdated: 'Aktualisiert',
      noContent: 'Keine Inhalte gefunden',
      searchPlaceholder: 'Inhalte durchsuchen...',
      filterByCategory: 'Nach Kategorie filtern',
      filterByStatus: 'Nach Status filtern',
      filterByType: 'Nach Typ filtern'
    },

    // Benutzer
    users: {
      title: 'Benutzer',
      createUser: 'Benutzer erstellen',
      editUser: 'Benutzer bearbeiten',
      deleteUser: 'Benutzer löschen',
      userName: 'Benutzername',
      userEmail: 'E-Mail',
      userRole: 'Rolle',
      userStatus: 'Status',
      userCreated: 'Erstellt',
      userLastLogin: 'Letzte Anmeldung',
      userActive: 'Aktiv',
      userInactive: 'Inaktiv',
      userBanned: 'Gesperrt',
      noUsers: 'Keine Benutzer gefunden',
      searchPlaceholder: 'Benutzer durchsuchen...',
      filterByRole: 'Nach Rolle filtern',
      filterByStatus: 'Nach Status filtern'
    },

    // Analytics
    analytics: {
      title: 'Analytics',
      overview: 'Übersicht',
      contentAnalytics: 'Content-Analytics',
      userAnalytics: 'Benutzer-Analytics',
      trafficAnalytics: 'Traffic-Analytics',
      revenueAnalytics: 'Umsatz-Analytics',
      timeRange: 'Zeitraum',
      last7Days: 'Letzte 7 Tage',
      last30Days: 'Letzte 30 Tage',
      last90Days: 'Letzte 90 Tage',
      lastYear: 'Letztes Jahr',
      customRange: 'Benutzerdefiniert',
      totalViews: 'Gesamtaufrufe',
      uniqueVisitors: 'Eindeutige Besucher',
      bounceRate: 'Absprungrate',
      avgSessionDuration: 'Durchschnittliche Sitzungsdauer',
      topContent: 'Top-Inhalte',
      topUsers: 'Top-Benutzer',
      topCountries: 'Top-Länder',
      topDevices: 'Top-Geräte',
      noData: 'Keine Daten verfügbar'
    },

    // Einstellungen
    settings: {
      title: 'Einstellungen',
      general: 'Allgemein',
      appearance: 'Erscheinungsbild',
      language: 'Sprache',
      notifications: 'Benachrichtigungen',
      security: 'Sicherheit',
      api: 'API',
      saveSettings: 'Einstellungen speichern',
      resetSettings: 'Einstellungen zurücksetzen',
      languageSelect: 'Sprache auswählen',
      themeSelect: 'Design auswählen',
      lightTheme: 'Helles Design',
      darkTheme: 'Dunkles Design',
      autoTheme: 'Automatisch',
      emailNotifications: 'E-Mail-Benachrichtigungen',
      pushNotifications: 'Push-Benachrichtigungen',
      smsNotifications: 'SMS-Benachrichtigungen',
      twoFactorAuth: 'Zwei-Faktor-Authentifizierung',
      changePassword: 'Passwort ändern',
      apiKey: 'API-Schlüssel',
      generateApiKey: 'API-Schlüssel generieren',
      settingsSaved: 'Einstellungen gespeichert',
      settingsReset: 'Einstellungen zurückgesetzt'
    },

    // Blog
    blog: {
      title: 'Blog',
      createPost: 'Beitrag erstellen',
      editPost: 'Beitrag bearbeiten',
      deletePost: 'Beitrag löschen',
      postTitle: 'Titel',
      postContent: 'Inhalt',
      postExcerpt: 'Auszug',
      postCategory: 'Kategorie',
      postTags: 'Tags',
      postAuthor: 'Autor',
      postPublished: 'Veröffentlicht',
      postDraft: 'Entwurf',
      postScheduled: 'Geplant',
      postFeatured: 'Empfohlen',
      postViews: 'Aufrufe',
      postComments: 'Kommentare',
      postLikes: 'Likes',
      postCreated: 'Erstellt',
      postUpdated: 'Aktualisiert',
      noPosts: 'Keine Beiträge gefunden',
      searchPlaceholder: 'Beiträge durchsuchen...',
      filterByCategory: 'Nach Kategorie filtern',
      filterByAuthor: 'Nach Autor filtern',
      filterByStatus: 'Nach Status filtern',
      readMore: 'Weiterlesen',
      readLess: 'Weniger anzeigen',
      sharePost: 'Beitrag teilen',
      likePost: 'Beitrag liken',
      commentOnPost: 'Kommentieren'
    },

    // Fehler
    errors: {
      networkError: 'Netzwerkfehler',
      serverError: 'Serverfehler',
      notFound: 'Nicht gefunden',
      unauthorized: 'Nicht autorisiert',
      forbidden: 'Zugriff verweigert',
      validationError: 'Validierungsfehler',
      unknownError: 'Unbekannter Fehler',
      tryAgain: 'Erneut versuchen',
      contactSupport: 'Support kontaktieren'
    },

    // Erfolg
    success: {
      contentCreated: 'Inhalt erfolgreich erstellt',
      contentUpdated: 'Inhalt erfolgreich aktualisiert',
      contentDeleted: 'Inhalt erfolgreich gelöscht',
      userCreated: 'Benutzer erfolgreich erstellt',
      userUpdated: 'Benutzer erfolgreich aktualisiert',
      userDeleted: 'Benutzer erfolgreich gelöscht',
      settingsSaved: 'Einstellungen erfolgreich gespeichert',
      passwordChanged: 'Passwort erfolgreich geändert',
      profileUpdated: 'Profil erfolgreich aktualisiert'
    }
  }
};

// Englische Übersetzungen
const en = {
  translation: {
    // General
    app: {
      title: 'Energetic Eternity CMS',
      loading: 'Loading...',
      error: 'Error',
      success: 'Success',
      cancel: 'Cancel',
      save: 'Save',
      delete: 'Delete',
      edit: 'Edit',
      create: 'Create',
      search: 'Search',
      filter: 'Filter',
      clear: 'Clear',
      back: 'Back',
      next: 'Next',
      previous: 'Previous',
      close: 'Close',
      confirm: 'Confirm',
      yes: 'Yes',
      no: 'No',
      ok: 'OK'
    },

    // Navigation
    nav: {
      dashboard: 'Dashboard',
      content: 'Content',
      users: 'Users',
      analytics: 'Analytics',
      settings: 'Settings',
      blog: 'Blog',
      blogManagement: 'Blog Management',
      logout: 'Logout'
    },

    // Authentication
    auth: {
      login: 'Login',
      logout: 'Logout',
      register: 'Register',
      email: 'Email',
      password: 'Password',
      confirmPassword: 'Confirm Password',
      forgotPassword: 'Forgot Password?',
      rememberMe: 'Remember Me',
      loginButton: 'Login',
      registerButton: 'Register',
      loginTitle: 'Login',
      registerTitle: 'Register',
      loginSubtitle: 'Sign in to your account',
      registerSubtitle: 'Create a new account',
      loginSuccess: 'Successfully logged in',
      registerSuccess: 'Registration successful',
      loginError: 'Login failed',
      registerError: 'Registration failed',
      invalidCredentials: 'Invalid credentials',
      emailRequired: 'Email is required',
      passwordRequired: 'Password is required',
      passwordMismatch: 'Passwords do not match',
      emailInvalid: 'Invalid email address',
      confirmLogout: 'Are you sure you want to logout?'
    },

    // Dashboard
    dashboard: {
      title: 'Dashboard',
      welcome: 'Welcome back',
      overview: 'Overview',
      recentContent: 'Recent Content',
      statistics: 'Statistics',
      totalUsers: 'Total Users',
      totalContent: 'Total Content',
      recentActivity: 'Recent Activity',
      noRecentContent: 'No recent content',
      noRecentActivity: 'No recent activity'
    },

    // Content
    content: {
      title: 'Content',
      createContent: 'Create Content',
      editContent: 'Edit Content',
      deleteContent: 'Delete Content',
      contentTitle: 'Title',
      contentDescription: 'Description',
      contentCategory: 'Category',
      contentStatus: 'Status',
      contentType: 'Type',
      contentFile: 'File',
      contentUrl: 'URL',
      contentTags: 'Tags',
      contentPublished: 'Published',
      contentDraft: 'Draft',
      contentArchived: 'Archived',
      contentFeatured: 'Featured',
      contentViews: 'Views',
      contentDownloads: 'Downloads',
      contentRating: 'Rating',
      contentCreated: 'Created',
      contentUpdated: 'Updated',
      noContent: 'No content found',
      searchPlaceholder: 'Search content...',
      filterByCategory: 'Filter by category',
      filterByStatus: 'Filter by status',
      filterByType: 'Filter by type'
    },

    // Users
    users: {
      title: 'Users',
      createUser: 'Create User',
      editUser: 'Edit User',
      deleteUser: 'Delete User',
      userName: 'Username',
      userEmail: 'Email',
      userRole: 'Role',
      userStatus: 'Status',
      userCreated: 'Created',
      userLastLogin: 'Last Login',
      userActive: 'Active',
      userInactive: 'Inactive',
      userBanned: 'Banned',
      noUsers: 'No users found',
      searchPlaceholder: 'Search users...',
      filterByRole: 'Filter by role',
      filterByStatus: 'Filter by status'
    },

    // Analytics
    analytics: {
      title: 'Analytics',
      overview: 'Overview',
      contentAnalytics: 'Content Analytics',
      userAnalytics: 'User Analytics',
      trafficAnalytics: 'Traffic Analytics',
      revenueAnalytics: 'Revenue Analytics',
      timeRange: 'Time Range',
      last7Days: 'Last 7 Days',
      last30Days: 'Last 30 Days',
      last90Days: 'Last 90 Days',
      lastYear: 'Last Year',
      customRange: 'Custom Range',
      totalViews: 'Total Views',
      uniqueVisitors: 'Unique Visitors',
      bounceRate: 'Bounce Rate',
      avgSessionDuration: 'Average Session Duration',
      topContent: 'Top Content',
      topUsers: 'Top Users',
      topCountries: 'Top Countries',
      topDevices: 'Top Devices',
      noData: 'No data available'
    },

    // Settings
    settings: {
      title: 'Settings',
      general: 'General',
      appearance: 'Appearance',
      language: 'Language',
      notifications: 'Notifications',
      security: 'Security',
      api: 'API',
      saveSettings: 'Save Settings',
      resetSettings: 'Reset Settings',
      languageSelect: 'Select Language',
      themeSelect: 'Select Theme',
      lightTheme: 'Light Theme',
      darkTheme: 'Dark Theme',
      autoTheme: 'Auto',
      emailNotifications: 'Email Notifications',
      pushNotifications: 'Push Notifications',
      smsNotifications: 'SMS Notifications',
      twoFactorAuth: 'Two-Factor Authentication',
      changePassword: 'Change Password',
      apiKey: 'API Key',
      generateApiKey: 'Generate API Key',
      settingsSaved: 'Settings saved',
      settingsReset: 'Settings reset'
    },

    // Blog
    blog: {
      title: 'Blog',
      createPost: 'Create Post',
      editPost: 'Edit Post',
      deletePost: 'Delete Post',
      postTitle: 'Title',
      postContent: 'Content',
      postExcerpt: 'Excerpt',
      postCategory: 'Category',
      postTags: 'Tags',
      postAuthor: 'Author',
      postPublished: 'Published',
      postDraft: 'Draft',
      postScheduled: 'Scheduled',
      postFeatured: 'Featured',
      postViews: 'Views',
      postComments: 'Comments',
      postLikes: 'Likes',
      postCreated: 'Created',
      postUpdated: 'Updated',
      noPosts: 'No posts found',
      searchPlaceholder: 'Search posts...',
      filterByCategory: 'Filter by category',
      filterByAuthor: 'Filter by author',
      filterByStatus: 'Filter by status',
      readMore: 'Read More',
      readLess: 'Read Less',
      sharePost: 'Share Post',
      likePost: 'Like Post',
      commentOnPost: 'Comment'
    },

    // Errors
    errors: {
      networkError: 'Network Error',
      serverError: 'Server Error',
      notFound: 'Not Found',
      unauthorized: 'Unauthorized',
      forbidden: 'Forbidden',
      validationError: 'Validation Error',
      unknownError: 'Unknown Error',
      tryAgain: 'Try Again',
      contactSupport: 'Contact Support'
    },

    // Success
    success: {
      contentCreated: 'Content created successfully',
      contentUpdated: 'Content updated successfully',
      contentDeleted: 'Content deleted successfully',
      userCreated: 'User created successfully',
      userUpdated: 'User updated successfully',
      userDeleted: 'User deleted successfully',
      settingsSaved: 'Settings saved successfully',
      passwordChanged: 'Password changed successfully',
      profileUpdated: 'Profile updated successfully'
    }
  }
};

// i18n konfigurieren
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      de,
      en
    },
    fallbackLng: 'de', // Deutsch als Standard
    debug: false,
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage']
    }
  });

export default i18n;
